import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-12" }
const _hoisted_2 = { class: "flex flex-col gap-4" }
const _hoisted_3 = { class: "text-xl font-bold text-gray-900 px-1 truncate" }
const _hoisted_4 = { class: "bg-white rounded border flex flex-col min-h-[200px]" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "px-2 text-gray-400 text-xs py-1"
}

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { Organization } from "shared/types/Organization";
import { Project } from "shared/types/Project";
import OrganizationTabProjectsHierarchyItem from "@/views/organizations/components/OrganizationTabProjectsHierarchyItem.vue";
import OrganizationTabProjectsItem from "@/views/organizations/components/OrganizationTabProjectsItem.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationTabProjects',
  props: {
    organization: {},
    organizationsByParentId: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const store = useStore();

const childOrganizations = computed(
  () => props.organizationsByParentId[props.organization._id] || [],
);

const projectsByCustomerNameSiteId = computed(() => {
  const projects: Project[] = store.state.projects || [];
  return projects.reduce((acc, project) => {
    acc[`${project.customer_name}_${project.site_id}`] = project;
    return acc;
  }, {} as Record<string, Project | undefined>);
});

const projectKeys = computed(() =>
  props.organization.explicit_projects
    .map((project) => `${project.customer_name}_${project.site_id}`)
    .filter((projectKey) => projectsByCustomerNameSiteId.value[projectKey]),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("organizations.projects")), 1),
      _createElementVNode("div", _hoisted_4, [
        (projectKeys.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectKeys.value, (projectKey) => {
                return (_openBlock(), _createBlock(OrganizationTabProjectsItem, {
                  key: projectKey,
                  project: projectsByCustomerNameSiteId.value[projectKey] as Project,
                  organization: _ctx.organization
                }, null, 8, ["project", "organization"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (childOrganizations.value.length === 0 && projectKeys.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(t)("organizations.no_projects")), 1))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(childOrganizations.value, (organizationInHierarchy) => {
          return (_openBlock(), _createBlock(OrganizationTabProjectsHierarchyItem, {
            key: organizationInHierarchy._id,
            organization: organizationInHierarchy,
            organizationsByParentId: _ctx.organizationsByParentId,
            projectsByCustomerNameSiteId: projectsByCustomerNameSiteId.value
          }, null, 8, ["organization", "organizationsByParentId", "projectsByCustomerNameSiteId"]))
        }), 128))
      ])
    ])
  ]))
}
}

})